// extracted by mini-css-extract-plugin
export var body = "_dm-0";
export var sectionHeader = "_dm-4";
export var shortcutColumns = "_dm-2";
export var shortcutList = "_dm-1";
export var shortcutSection = "_dm-3";